import React from 'react';

import { Tooltip, Button, InputNumber, Select } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { Form } from '@ant-design/compatible';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getRecibosSinDepositar from '../../../graphql/querys/contravenciones/getRecibosSinDepositar.graphql';

import getSucursales from '../../../graphql/querys/organismos/getSucursales.graphql';

const FormItem = Form.Item;
const Option = Select.Option;

@compose(
  graphql(getUsuario),
  graphql(getSucursales, { name: 'getSucursales' }),
  graphql(getOrganismos, { name: 'getOrganismos' }),
  graphql(getRecibosSinDepositar, {
    name: 'getRecibosSinDepositar',
    options: {
      fetchPolicy: 'network-only',
    },
  })
)
class FormDepositoContravencion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sumaRecibos: 0,
    };
  }

  onSubmit = e => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        delete values.sumaRecibos;
        this.props.onSubmit(values);
      }
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('HOLA: ', nextProps);
    if (!nextProps.data.loading && nextProps.data.getUsuario) {
      // console.log('Entre con: ', nextProps.data.getUsuario);
      this.cambiarOrganismo(nextProps.data.getUsuario.organismo._id);
    }
  }

  checkNumero = (rule, value, callback) => {
    var bool = /^[0-9]*$/.test(value);
    if (bool) {
      callback();
    } else {
      callback('El numero es unicamente con numeros, sin puntos');
    }
  };

  cambiarOrganismo = idOrganismo => {
    this.setState({
      ...this.state,
      idOrganismo: idOrganismo,
      nombreOrganismo: this.obtenerNombreOrganismo(idOrganismo),
    });
  };

  crearOpciones(sucursal) {
    return (
      <Option key={sucursal._id} value={sucursal._id}>
        {sucursal.nombre}
      </Option>
    );
  }

  generarOpcionesRecibos(recibo) {
    // console.log('EL RECIBO ES: ', recibo);
    return (
      <Option key={recibo._id} value={recibo._id}>
        {recibo.numero +
          ' / ' +
          recibo.expediente.codigoOrganismo +
          '-' +
          recibo.expediente.tipo.nombre +
          '-' +
          recibo.expediente.numero +
          '-' +
          recibo.expediente.anio +
          ' / ' +
          recibo.contraventor.persona.nombre +
          ' ' +
          recibo.contraventor.persona.apellido}
      </Option>
    );
  }

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.getOrganismos.getOrganismos, {
      _id: idOrganismo,
    });
    organismo
      ? (nombre = organismo.nombre)
      : (nombre = this.props.data.getUsuario.organismo.nombre);
    return nombre;
  };

  render() {
    // console.log('render');
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const { getFieldDecorator } = this.props.form;

    const { data } = this.props;
    if (data.loading) {
      return <Loading />;
    }

    if (!data.getUsuario || !this.props.getOrganismos.getOrganismos) {
      return <Loading />;
    }

    let usuario = this.props.data.getUsuario;

    let listaRecibos = this.props.getRecibosSinDepositar.getRecibosSinDepositar;
    if (listaRecibos && listaRecibos.length > 0) {
      var opcionesRecibos = _.map(listaRecibos, this.generarOpcionesRecibos);
    }

    let valor = 0;

    _.each(this.props.form.getFieldsValue().idRecibos, id => {
      let recibo = _.find(listaRecibos, { _id: id });
      valor = valor + Number(recibo.contraventor.sancion.monto);
    });

    return (
      <div>
        <h3 className="tituloForm">Datos del Deposito</h3>

        <Form
          onSubmit={this.onSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Organismo
                <Tooltip title="Seleccione el organismo del reporte">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idOrganismo', {
              initialValue: usuario.organismo._id,
              rules: [
                {
                  type: 'string',
                  required: true,
                  message: 'Por favor, seleccione el organismo del deposito',
                },
              ],
            })(
              <Select
                style={{ width: 600, marginRight: 20 }}
                id="organismos"
                placeholder="Seleccione el organismo"
                disabled={true}
                onSelect={valor => this.cambiarOrganismo(valor)}
              >
                {this.props.getOrganismos.getOrganismos &&
                  this.props.getOrganismos.getOrganismos.map(organismo => (
                    <Select.Option key={organismo._id}>
                      {organismo.nombre}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Recibos
                <Tooltip title="Seleccione los recibos">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idRecibos')(
              <Select
                style={{ width: 600, marginRight: 20 }}
                id="selectorRecibos"
                mode="multiple"
                placeholder="Seleccione los recibos"
              >
                {opcionesRecibos}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={<span>Montos de los Recibos</span>}
          >
            {getFieldDecorator('sumaRecibos', {
              initialValue: valor,
            })(<InputNumber readOnly style={{ width: 600 }} />)}
            <span className="ant-form-text"> $</span>
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Importe total del deposito
                <Tooltip title="Importe que aparece en el comprobante del deposito">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('importe', {
              rules: [
                {
                  required: true,
                  message:
                    'Por favor, ingresar el numero de forma correcta, sin puntos!',
                  validator: this.checkNumero,
                },
              ],
            })(<InputNumber style={{ width: 600 }} />)}
            <span className="ant-form-text"> $</span>
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: '40%' }}
            >
              Confirmar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    moment.locale();
    return {
      fecha: Form.createFormField({
        value:
          props.datos && props.datos.fecha
            ? moment(new Date(props.datos.fecha), 'DD/MM/YYYY')
            : moment(),
      }),
      idSucursal: Form.createFormField({
        value:
          props.datos && props.datos.sucursal ? props.datos.sucursal._id : '',
      }),
      numBoletaDeposito: Form.createFormField({
        value: props.datos ? props.datos.numBoletaDeposito : '',
      }),
      importe: Form.createFormField({
        value: props.datos ? props.datos.importe : '',
      }),
    };
  },
})(withApollo(FormDepositoContravencion));
